import { ActionTree } from 'vuex';
import { ITilesViewState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<ITilesViewState, RootState> = {
    async load({ dispatch, commit, rootState }, args: {deviceNumber: string}): Promise<any> {
        try {
            const views = await dispatch('views/load', args, {root: true});

            let view = views.tiles as ITilesViewState;
            if (!view) {
                view = {
                    devices: {},
                };
            }
            commit('loaded', { deviceNumber: args.deviceNumber, view });
        } catch (e) {
            throw e;
        }
    },
    async pushToViews({state, dispatch}, args: {deviceNumber: string}): Promise<any> {
        const view = state.devices[args.deviceNumber];
        if (view) {
            await dispatch('views/store', {
                deviceNumber: args.deviceNumber,
                key: 'tiles',
                payload: view },
                { root: true },
            );
        }
    },
};
